/*
 * Comnexus API istemcisi (HollyConnect yerine).
 *
 * Tema tarafındaki tüm Comnexus çağrıları bu dosyadaki yardımcılardan geçer:
 *   - COMNEXUS_API        uç nokta adresleri (taban URL: window.theme.comnexusBaseUrl)
 *   - comnexusFetch()     JSON istek, Bearer ekleme, yanıt zarfı ayrıştırma
 *   - comnexusAuth        müşteri token'ı (sayfa belleğinde önbellek)
 *   - toE164TR() vb.      telefon ve Shopify GID dönüşümleri
 *   - COMNEXUS_OTP        OTP kod uzunluğu ve süresi, comnexusOtpErrorMessage() hata metinleri
 *
 * Token mantığı bilerek yalnızca comnexusAuth içinde. Comnexus imzalı bir
 * yöntem sunduğunda (ör. App Proxy imzası) değişmesi gereken tek yer burası.
 *
 * Yükleme: layout/theme.liquid <head> içinde defer ile, section script'lerinden önce.
 */
(function () {
  'use strict';

  var DEFAULT_TIMEOUT_MS = 20000;

  function getBaseUrl() {
    var base = (window.theme && window.theme.comnexusBaseUrl) || '';
    return String(base).trim().replace(/\/+$/, '');
  }

  function isConfigured() {
    return getBaseUrl() !== '';
  }

  function endpoint(path) {
    return getBaseUrl() + path;
  }

  // Adresler her okunduğunda taban URL'den üretilir; ayar geç tanımlansa da doğru adres döner.
  var PATHS = {
    GET_TOKEN: '/api/v1/customer/get-token',

    GET_OTP: '/api/v1/customer/request-otp',
    CHECK_OTP: '/api/v1/customer/verify-otp',
    // Kayıt (v2): verify-otp tek kullanımlık verificationToken döner, register müşteriyi
    // sunucuda oluşturur. v1 OTP uçları profil güncelleme gibi akışlar için korunuyor.
    REGISTER_REQUEST_OTP: '/api/v2/customer/request-otp',
    REGISTER_VERIFY_OTP: '/api/v2/customer/verify-otp',
    REGISTER: '/api/v2/customer/register',
    // Müşteri hesabı (v2, token istemez): durum sorgusu, telefonla giriş/şifre sıfırlama, aktivasyon.
    // Cevap: { exists, requiresActivation, status, customerEmail (maskeli), emailMatch, isPlaceholderEmail }
    GET_MAIL_STATUS: '/api/v2/customer/check-email',
    CHECK_PHONE: '/api/v2/customer/check-phone',
    PHONE_LOGIN: '/api/v2/customer/phone-login',
    PHONE_RECOVER: '/api/v2/customer/phone-recover',
    SEND_ACTIVATION_EMAIL: '/api/v2/customer/send-activation',
    // Sadakat segmenti: CRM'den tazelenir, değiştiyse Shopify metafield'ına yazılır.
    REFRESH_SEGMENT_WEB: '/api/v2/customer/refresh-segment-web',
    UPDATE_USER: '/api/v1/customer/update-profile-web',
    DELETE_USER: '/api/v1/customer/passive',
    GET_COUPONS: '/api/v1/customer/discount-codes',
    CONTACT_FORM: '/api/v1/customer/request-form',
    // Kiralık Yerim Var: anonim, yapılandırılmış gövde (address nesnesi); panelde "Kiralık Yerim Var" konusu
    PROPERTY_FORM: '/api/v1/customer/property-form',
    LET_ME_KNOW: '/api/v1/customer/stock-request-notify',
    // Fiyat düşünce haber ver: anonim, { email, shopifyProductVariantId (gid) }; hata olsa da HTTP 200 + succeeded:false
    PRICE_DROP_NOTIFY: '/api/v2/customer/price-drop-notify',

    GET_FAVS: '/api/v1/customer-favorites',
    ADD_FAV: '/api/v1/customer-favorites',
    REMOVE_FAV: '/api/v1/customer-favorites/remove',

    GET_STORES: '/api/v1/store',
    GET_STORE_STOCK: '/api/v1/product/store-stock',

    ORDER_LINES: '/api/v1/order/lines',
    CANCEL_REQUEST: '/api/v1/order/cancel',
    RETURN_REQUEST: '/api/v1/order/return',
    GET_GUEST_ORDER: '/api/v1/order/guest-order-detail',
    CANCEL_GUEST_ORDER: '/api/v1/order/guest-cancel-request',
    RETURN_GUEST_ORDER: '/api/v1/order/guest-return-request',
    GET_INSTALLMENT: '/api/v1/order/installments',
    CANCEL_REASONS: '/api/v1/cancellation-reasons',
    RETURN_REASONS: '/api/v1/return-reasons'
  };

  var COMNEXUS_API = {};
  Object.keys(PATHS).forEach(function (key) {
    Object.defineProperty(COMNEXUS_API, key, {
      enumerable: true,
      get: function () {
        return endpoint(PATHS[key]);
      }
    });
  });

  // GET /api/v1/order/{order.name}/detail (Bearer) → { orderLines[], invoices[] }. Ad "#" ile: "#ORDER1112".
  COMNEXUS_API.orderDetail = function (orderName) {
    return endpoint('/api/v1/order/' + encodeURIComponent(orderName) + '/detail');
  };

  // Shopify App Proxy (yalnız v2): /apps/api/* → https://eveshop-api.comnexus.io/api/v2/*
  // Shopify isteği imzalar (signature + logged_in_customer_id); token gönderilmez. Aynı alan adı, CORS yok.
  var APP_PROXY_V2 = '/apps/api';

  // GET /apps/api/invoice/order/{order.name} → …/api/v2/invoice/order/{order.name} (PDF)
  COMNEXUS_API.orderInvoice = function (orderNumber) {
    return APP_PROXY_V2 + '/invoice/order/' + encodeURIComponent(orderNumber);
  };

  // POST /api/v1/order/replace-rma-code/{order.name}/{eskiRMA}
  COMNEXUS_API.replaceRmaCode = function (orderName, oldRmaCode) {
    return endpoint(
      '/api/v1/order/replace-rma-code/' +
        encodeURIComponent(orderName) +
        '/' +
        encodeURIComponent(oldRmaCode)
    );
  };

  /* ---------------------------------------------------------------------- */
  /* Hata tipi                                                              */
  /* ---------------------------------------------------------------------- */

  // code: 'not_configured' | 'network' | 'timeout' | 'auth' | 'http' | 'api'
  function ComnexusError(code, message, details) {
    var error = new Error(message || code);
    error.name = 'ComnexusError';
    error.code = code;
    error.status = (details && details.status) || 0;
    error.messages = (details && details.messages) || [];
    error.data = details && details.data !== undefined ? details.data : null;
    error.raw = (details && details.raw) || null;
    return error;
  }

  /* ---------------------------------------------------------------------- */
  /* Yanıt zarfı                                                            */
  /* ---------------------------------------------------------------------- */

  function parseMaybeJson(value) {
    if (typeof value !== 'string') return value;
    try {
      return JSON.parse(value);
    } catch (e) {
      return value;
    }
  }

  // messages[] bazen string, bazen {message} / {text} nesnesi.
  function normalizeMessages(raw) {
    var list = raw && raw.messages;
    if (!Array.isArray(list)) list = list ? [list] : [];
    return list
      .map(function (item) {
        if (item == null) return '';
        if (typeof item === 'string') return item;
        return item.message || item.text || item.description || '';
      })
      .filter(Boolean);
  }

  // Comnexus başarı işaretleri: succeeded (genel), success (CONTACT_FORM),
  // isSuccess / data.isSuccess / data.isSucccess (iade uçları, üç "c" dahil).
  function isEnvelopeSuccess(raw) {
    if (!raw || typeof raw !== 'object') return false;
    if (raw.succeeded === true || raw.success === true || raw.isSuccess === true) return true;
    var data = raw.data;
    return !!(data && typeof data === 'object' && (data.isSuccess === true || data.isSucccess === true));
  }

  // Bazı uçlarda gerçek gövde data.body içinde string olarak geliyor.
  function unwrapData(raw) {
    if (!raw || typeof raw !== 'object') return raw;
    var data = raw.data;
    if (data && typeof data === 'object' && typeof data.body === 'string') {
      var body = parseMaybeJson(data.body);
      if (body && typeof body === 'object') return body;
    }
    return data;
  }

  /* ---------------------------------------------------------------------- */
  /* comnexusFetch                                                          */
  /* ---------------------------------------------------------------------- */

  /**
   * @param {string} url      COMNEXUS_API.* adresi
   * @param {object} [opts]
   *   method     'GET' | 'POST' ... (varsayılan: body varsa POST, yoksa GET)
   *   body       nesne (JSON'a çevrilir) ya da hazır string
   *   query      { anahtar: değer } → URL parametreleri
   *   auth       true ise Bearer token eklenir (comnexusAuth.getToken)
   *   identity   auth için kimlik ({email, customerId}); verilmezse oturumdaki müşteri
   *   envelope   false ise zarf aranmaz, yalnızca HTTP 2xx kontrol edilir (ör. ORDER_LINES)
   *   timeoutMs  varsayılan 20000
   *   signal     dışarıdan AbortSignal
   * @returns {Promise<{data, messages, raw, status}>}
   * @throws  ComnexusError
   */
  async function comnexusFetch(url, opts) {
    opts = opts || {};

    if (!isConfigured()) {
      throw ComnexusError('not_configured', 'Comnexus base URL is not configured');
    }

    var hasBody = opts.body !== undefined && opts.body !== null;
    var method = (opts.method || (hasBody ? 'POST' : 'GET')).toUpperCase();

    // Accept-Language: v2 uçları messages[0]'ı bu dile göre döner (yoksa bazıları İngilizce).
    var headers = { Accept: 'application/json', 'Accept-Language': 'tr' };
    if (hasBody) headers['Content-Type'] = 'application/json';
    if (opts.headers) {
      Object.keys(opts.headers).forEach(function (key) {
        headers[key] = opts.headers[key];
      });
    }

    if (opts.query) {
      var params = new URLSearchParams();
      Object.keys(opts.query).forEach(function (key) {
        var value = opts.query[key];
        if (value !== undefined && value !== null) params.append(key, String(value));
      });
      var qs = params.toString();
      if (qs) url += (url.indexOf('?') === -1 ? '?' : '&') + qs;
    }

    var body = hasBody ? (typeof opts.body === 'string' ? opts.body : JSON.stringify(opts.body)) : undefined;

    async function send(forceNewToken) {
      if (opts.auth) {
        var token = await comnexusAuth.getToken({ identity: opts.identity, force: forceNewToken });
        if (!token) throw ComnexusError('auth', 'Comnexus token could not be obtained');
        headers.Authorization = 'Bearer ' + token;
      }

      var controller = typeof AbortController !== 'undefined' ? new AbortController() : null;
      var timeoutMs = opts.timeoutMs || DEFAULT_TIMEOUT_MS;
      var timedOut = false;
      var timer = null;
      if (controller) {
        timer = setTimeout(function () {
          timedOut = true;
          controller.abort();
        }, timeoutMs);
        if (opts.signal) {
          if (opts.signal.aborted) controller.abort();
          else opts.signal.addEventListener('abort', function () { controller.abort(); });
        }
      }

      try {
        return await fetch(url, {
          method: method,
          headers: headers,
          body: body,
          signal: controller ? controller.signal : opts.signal
        });
      } catch (e) {
        if (timedOut) throw ComnexusError('timeout', 'Comnexus request timed out');
        if (e && e.name === 'AbortError') throw e;
        throw ComnexusError('network', (e && e.message) || 'Network error');
      } finally {
        if (timer) clearTimeout(timer);
      }
    }

    var response = await send(false);

    // Token süresi dolmuş olabilir: bir kez yeni token ile tekrar dene.
    if (opts.auth && (response.status === 401 || response.status === 403)) {
      comnexusAuth.clear();
      response = await send(true);
    }

    var text = '';
    try {
      text = await response.text();
    } catch (e) {
      text = '';
    }
    var raw = text ? parseMaybeJson(text) : null;
    var messages = normalizeMessages(raw);
    var details = { status: response.status, messages: messages, data: unwrapData(raw), raw: raw };

    if (!response.ok) {
      var code = response.status === 401 || response.status === 403 ? 'auth' : 'http';
      throw ComnexusError(code, messages[0] || 'HTTP ' + response.status, details);
    }

    if (opts.envelope !== false && !isEnvelopeSuccess(raw)) {
      throw ComnexusError('api', messages[0] || 'Comnexus request failed', details);
    }

    return details;
  }

  // v2 hesap uçlarının makine okunur hata kodu (ekran seçimi buna göre yapılır, metne göre değil):
  // INVALID_CREDENTIALS | ACTIVATION_REQUIRED | COMPLETE_REGISTRATION | NOT_FOUND. 429 → TOO_MANY_REQUESTS.
  function errorCode(error) {
    if (!error) return null;
    if (error.status === 429) return 'TOO_MANY_REQUESTS';
    var data = error.data;
    return (data && typeof data === 'object' && data.errorCode) || null;
  }

  // v2 uçlarının kullanıcıya gösterilecek metni (Accept-Language: tr). Yoksa fallback.
  function userMessage(error, fallback) {
    var message = error && error.messages && error.messages[0];
    return message && /\s/.test(String(message).trim()) ? String(message).trim() : fallback;
  }

  /* ---------------------------------------------------------------------- */
  /* comnexusAuth                                                           */
  /* ---------------------------------------------------------------------- */

  var comnexusAuth = (function () {
    var cache = {};

    function sessionIdentity() {
      var identity = window.theme && window.theme.customerIdentity;
      if (!identity || !identity.id || !identity.email) return null;
      return { email: identity.email, customerId: identity.id };
    }

    function cacheKey(identity) {
      return String(identity.customerId) + '|' + String(identity.email).toLowerCase();
    }

    async function requestToken(identity) {
      var result = await comnexusFetch(COMNEXUS_API.GET_TOKEN, {
        method: 'POST',
        body: { email: identity.email, customerId: identity.customerId }
      });
      var raw = result.raw || {};
      var token = (result.data && result.data.token) || raw.token || null;
      if (!token) throw ComnexusError('auth', 'Comnexus token missing in response', result);
      return token;
    }

    return {
      /**
       * Oturumdaki müşteri için token. Misafir akışlarında (ör. misafir iptal)
       * identity: {email, customerId} ile çağrılır.
       * Hata durumunda null döner; ayrıntı konsola yazılır.
       */
      getToken: async function (opts) {
        opts = opts || {};
        var identity = opts.identity || sessionIdentity();
        if (!identity || !identity.email || !identity.customerId) return null;

        // Misafir yanıtındaki müşteri kimliği GID olarak geliyor; sayıya indir.
        var customerId = identity.customerId;
        if (String(customerId).indexOf('gid://') === 0) customerId = Number(fromGid(customerId));
        identity = { email: identity.email, customerId: customerId };
        var key = cacheKey(identity);

        if (opts.force) delete cache[key];
        if (!cache[key]) {
          cache[key] = requestToken(identity).catch(function (error) {
            delete cache[key];
            console.error('[comnexus] token error:', error);
            return null;
          });
        }
        return cache[key];
      },

      clear: function () {
        cache = {};
      },

      isLoggedIn: function () {
        return !!sessionIdentity();
      },

      identity: sessionIdentity
    };
  })();

  /* ---------------------------------------------------------------------- */
  /* Telefon ve GID yardımcıları                                            */
  /* ---------------------------------------------------------------------- */

  // Türkiye cep numarasını 10 haneye indirger: "0 (532) 123 45 67", "+905321234567",
  // "905321234567" → "5321234567". Geçersizse boş string.
  function toTR10(phone) {
    var digits = String(phone == null ? '' : phone).replace(/\D/g, '');
    if (digits.length === 12 && digits.indexOf('90') === 0) digits = digits.slice(2);
    else if (digits.length === 11 && digits.charAt(0) === '0') digits = digits.slice(1);
    return digits.length === 10 ? digits : '';
  }

  // OTP ve profil uçları: "+90XXXXXXXXXX"
  function toE164TR(phone) {
    var tr10 = toTR10(phone);
    return tr10 ? '+90' + tr10 : '';
  }

  // CONTACT_FORM: "90XXXXXXXXXX" ("+" yok)
  function toCrmPhone(phone) {
    var tr10 = toTR10(phone);
    return tr10 ? '90' + tr10 : '';
  }

  function toGid(type, id) {
    if (id === undefined || id === null || id === '') return '';
    var value = String(id);
    if (value.indexOf('gid://') === 0) return value;
    return 'gid://shopify/' + type + '/' + value;
  }

  function toProductGid(id) {
    return toGid('Product', id);
  }

  function toVariantGid(id) {
    return toGid('ProductVariant', id);
  }

  function toOrderGid(id) {
    return toGid('Order', id);
  }

  // "gid://shopify/Order/123?x=1" → "123"; sayısal değer olduğu gibi döner.
  function fromGid(gid) {
    if (gid === undefined || gid === null) return '';
    var match = String(gid).match(/(\d+)(?:\?.*)?$/);
    return match ? match[1] : '';
  }

  /* ---------------------------------------------------------------------- */
  /* OTP                                                                    */
  /* ---------------------------------------------------------------------- */

  // Kod uzunluğu tema ayarından gelir (Jumbo'da 4). Süre Jumbo'daki değer.
  var COMNEXUS_OTP = {
    get LENGTH() {
      var length = Number(window.theme && window.theme.comnexusOtpLength);
      return length > 0 ? length : 4;
    },
    DURATION_SEC: 180
  };

  // Comnexus OTP hata anahtarları. messages[0] ya doğrudan anahtar ("otp_sms_limit_exceeded")
  // ya da metin ("Invalid Code") olarak geliyor; ikisi de aynı biçime indirgenir.
  var OTP_ERROR_MESSAGES = {
    phone_not_found: 'Telefon bulunamadı.',
    phone_not_valid: 'Geçersiz telefon numarası.',
    phone_number_already_validated:
      'Bu telefon numarası ve e-posta ile zaten doğrulama yapıldı. Lütfen müşteri hizmetleriyle iletişime geçin.',
    already_exist_email: 'Bu e-posta adresi zaten mevcut.',
    invalid_code: 'SMS kodunuz geçerli değil.',
    code_timeout: 'Kod süresi doldu!',
    otp_sms_limit_exceeded: 'Çok fazla deneme yaptınız. Lütfen daha sonra tekrar deneyin.',
    try_again: 'Hata! Lütfen daha sonra tekrar deneyin.'
  };

  function otpErrorMessage(error, fallback) {
    fallback = fallback || OTP_ERROR_MESSAGES.try_again;
    if (!error || (error.code !== 'api' && error.code !== 'http')) return fallback;
    var raw = (error.messages && error.messages[0]) || '';
    var key = raw.trim().toLowerCase().replace(/\s+/g, '_');
    if (OTP_ERROR_MESSAGES[key]) return OTP_ERROR_MESSAGES[key];
    if (/phone.*already.*registered/.test(key)) return 'Bu telefon numarası zaten kullanımda.';
    // Eşlenmemiş ama kullanıcıya yönelik cümle (ör. v2 uçlarının Türkçe mesajları) olduğu gibi
    // gösterilir; tek kelimelik anahtar/teknik değerler için genel metin kullanılır.
    if (raw && /\s/.test(raw.trim())) return raw.trim();
    if (raw) console.warn('[comnexus] unmapped OTP error:', raw);
    return fallback;
  }

  /* ---------------------------------------------------------------------- */
  /* Mağazalar (GET_STORES)                                                 */
  /* ---------------------------------------------------------------------- */

  // Yanıt (Jumbo): data[] { shopifyId (Location GID), name, address1, address2, district, city,
  // phone, latitude, longitude }. Eve'nin kullandığı çalışma saatleri, harita linki, mağaza kodu ve
  // mağaza tipi (Eve / Pinkflash) alanlarının adı henüz belli değil (geçiş planı §6 soru 8);
  // olası adların hepsi okunur.
  var comnexusStores = (function () {
    // Önbellek yok: Comnexus'ta yapılan değişiklikler (çalışma saati vb.) sayfa açılışında hemen görünür.
    // memory yalnızca aynı sayfadaki tekrar çağrıları tek isteğe indirir.
    var memory = null;
    var pending = null;

    function storeTypes(item) {
      var values = [];
      (Array.isArray(item.metaValues) ? item.metaValues : []).forEach(function (meta) {
        if (String((meta && meta.key) || '').trim().toLowerCase() === 'store_type') values.push(meta.value);
      });
      // brands: ["laka", "pinkflash"] (Comnexus /store yanıtı); filtre "pinkflash" bu listeden eşleşir.
      [item.brands, item.storeType, item.store_type, item.type].forEach(function (value) {
        if (value) values.push(value);
      });
      return values
        .reduce(function (all, value) {
          return all.concat(Array.isArray(value) ? value : String(value).split(','));
        }, [])
        .map(function (value) {
          return String(value).trim().toLowerCase();
        })
        .filter(Boolean);
    }

    function normalize(item) {
      var latitude = Number(item.latitude);
      var longitude = Number(item.longitude);
      var hasCoords = isFinite(latitude) && isFinite(longitude) && (latitude !== 0 || longitude !== 0);
      return {
        id: fromGid(item.shopifyId) || '',
        code: String(item.code || item.storeCode || item.erpCode || '').trim(),
        name: item.name || '',
        city: item.city || '',
        district: item.district || '',
        address: [item.address1, item.address2].filter(Boolean).join(' ') || item.address || '',
        phone: item.phone || '',
        latitude: hasCoords ? latitude : null,
        longitude: hasCoords ? longitude : null,
        workingHours: item.workingHours || item.schedule || null,
        mapUrl:
          item.mapUrl ||
          (hasCoords ? 'https://www.google.com/maps/search/?api=1&query=' + latitude + ',' + longitude : ''),
        types: storeTypes(item)
      };
    }

    function all() {
      if (memory) return Promise.resolve(memory);
      if (pending) return pending;
      pending = window.comnexusFetch(COMNEXUS_API.GET_STORES, { timeoutMs: 15000 })
        .then(function (result) {
          var list = Array.isArray(result.data) ? result.data : [];
          memory = list.filter(Boolean).map(normalize);
          return memory;
        })
        .finally(function () {
          pending = null;
        });
      return pending;
    }

    // Sipariş metafield'ındaki mağaza kodu (hollyaccount.storeCode) ya da Location ID ile eşleştirme.
    function find(codeOrId) {
      var key = String(codeOrId || '').trim().toLowerCase();
      if (!key) return Promise.resolve(null);
      var numeric = /^\d+$/.test(key) || key.indexOf('gid://') === 0 ? fromGid(codeOrId) : '';
      return all().then(function (stores) {
        return (
          stores.find(function (store) {
            return (store.code && store.code.toLowerCase() === key) || (numeric && store.id === numeric);
          }) || null
        );
      });
    }

    return { all: all, find: find, normalize: normalize };
  })();

  /* ---------------------------------------------------------------------- */
  /* Global erişim                                                          */
  /* ---------------------------------------------------------------------- */

  window.COMNEXUS_API = COMNEXUS_API;
  window.ComnexusError = ComnexusError;
  window.comnexusFetch = comnexusFetch;
  window.comnexusAuth = comnexusAuth;
  window.comnexusIsConfigured = isConfigured;
  window.COMNEXUS_OTP = COMNEXUS_OTP;
  window.comnexusOtpErrorMessage = otpErrorMessage;
  window.comnexusErrorCode = errorCode;
  window.comnexusUserMessage = userMessage;
  window.comnexusStores = comnexusStores;
  window.toTR10 = toTR10;
  window.toE164TR = toE164TR;
  window.toCrmPhone = toCrmPhone;
  window.toProductGid = toProductGid;
  window.toVariantGid = toVariantGid;
  window.toOrderGid = toOrderGid;
  window.fromGid = fromGid;
})();
